import React, {useEffect} from 'react';
import {connect} from 'react-redux';

import _EditUser from './EditUser/_EditUser';
import _EditAdmin from './EditAdmin/_EditAdmin';

import actions from '../../redux/actions';
import './Config_v2.scss';
import Loader from '../../common/components/Loader/Loader';

const _Config = (props) => {
    const {
        setAdminSelected,
        setProviderSelected,
        roleName,
        setSelfState,
        cleanSelectSelf,
        selectSelf,
    } = props;

    useEffect(() => {
        if (roleName === 'ADMIN' && !setAdminSelected || roleName ===! 'ADMIN' && !setProviderSelected) {
            setProviderSelected(undefined);
            setAdminSelected(undefined);
            selectSelf();
        }
        // eslint-disable-next-line
    }, []);

    if (setAdminSelected === undefined || setProviderSelected === undefined) {
        return <Loader/>;
    }

  return roleName === 'ADMIN'? (
    <_EditAdmin {...props} currentUser={true} />
  ) : (
    <_EditUser {...props} currentUser={true} />
  );
};

const mapStateToProps = (state) => ({
    roleName: state.login.userInfo.role.name,
    adminSelected: state.home.adminSelected,
    providerSelected: state.home.providerSelected,
    setSelfState: state.home.setSelfState,
    userSelected: state.login.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
    selectSelf: () => dispatch(actions.home.selectSelf()),
    setProviderSelected: (providerSelected) => dispatch(actions.home.setProviderSelected(providerSelected)),
    setAdminSelected: (adminSelected) => dispatch(actions.home.setAdminSelected(adminSelected)),
    cleanSelectSelf: () => dispatch(actions.home.cleanSelectSelf()),
});

export default connect(mapStateToProps, mapDispatchToProps)(_Config);
